
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 33 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.8346 16.4036C29.8346 23.7674 23.8651 29.737 16.5013 29.737C9.13751 29.737 3.16797 23.7674 3.16797 16.4036C3.16797 9.03985 9.13751 3.07031 16.5013 3.07031C23.8651 3.07031 29.8346 9.03985 29.8346 16.4036ZM17.2724 12.8869C15.9756 13.4263 13.3837 14.5428 9.49673 16.2362C8.86555 16.4872 8.53491 16.7328 8.50481 16.9729C8.45394 17.3786 8.96208 17.5384 9.65404 17.756C9.74816 17.7856 9.84568 17.8163 9.94566 17.8488C10.6264 18.0701 11.5422 18.329 12.0183 18.3392C12.4501 18.3486 12.9321 18.1705 13.4642 17.8051C17.0959 15.3537 18.9706 14.1146 19.0883 14.0878C19.1713 14.069 19.2864 14.0453 19.3644 14.1146C19.4423 14.1839 19.4347 14.3151 19.4264 14.3503C19.3761 14.5649 17.3814 16.4193 16.3492 17.379C16.0274 17.6781 15.7991 17.8903 15.7525 17.9388C15.648 18.0474 15.5414 18.1501 15.439 18.2488C14.8066 18.8585 14.3323 19.3157 15.4653 20.0623C16.0098 20.4211 16.4455 20.7178 16.8801 21.0138C17.3548 21.3371 17.8283 21.6595 18.4409 22.0611C18.5969 22.1634 18.746 22.2696 18.8912 22.3731C19.4436 22.767 19.9399 23.1208 20.5531 23.0644C20.9093 23.0316 21.2774 22.6966 21.4643 21.6974C21.906 19.336 22.7742 14.2197 22.9749 12.1114C22.9924 11.9267 22.9703 11.6903 22.9526 11.5865C22.9348 11.4827 22.8977 11.3349 22.7628 11.2254C22.6031 11.0958 22.3564 11.0685 22.2461 11.0704C21.7446 11.0792 20.9752 11.3468 17.2724 12.8869Z","fill":"currentColor"}})])
          )
        }
      }
    